import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const About = () => {
  const [leftRef, inLeftView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 10% of the image is visible
  });
  const [rightRef, inRightView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 10% of the image is visible
  });
  return (
    <section className="aboutus-section overflow-hidden">
      <div className="container">
        <div className="row">
          <div ref={leftRef} className={`col-lg-4 col-md-4 col-sm-12 col-12 ${inLeftView ? 'animate__animated animate__slideInLeft' : ''}`}>
            <div className="aboutus_content">
              <h4>About Us</h4>
              <h2 className="mb-0 ">Why Should You Choose Us</h2>
            </div>
          </div>
          <div ref={rightRef} className={`col-lg-8 col-md-8 col-sm-12 col-12 ${inRightView ? 'animate__animated animate__slideInRight' : ''}`}>
            <div className="aboutus_text" data-aos="fade-left">
              <p className="mb-0 ">
                Cosmic Advice is your gateway to customized planetary
                consultation, offering spiritual and metaphysical guidance and
                advice to users based on their cosmic conditions.
                <a href="/about-us" target="_blank" className="ml-1">Read More</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
